import { SelectorConfig } from '@/src/types/itinerary'
import { useTranslations } from 'next-intl'
import AddonsItemCard from './addonsItemCard'

const AddonsItemCardWrapper = ({
    imageUrl,
    description,
    price,
    itemIndicator,
    selectorConfig,
    onAddClick,
    onRemoveClick
}: {
    imageUrl?: string | null
    baggageIcon?: React.ReactNode
    description: string
    price: string
    itemIndicator: {
        show: boolean
        color: string
    }
    selectorConfig: SelectorConfig
    onAddClick: () => void
    onRemoveClick: () => void
}) => {
    const t = useTranslations('itineraryPage.addons')
    return (
        <AddonsItemCard
            selectorConfig={selectorConfig}
            imageUrl={imageUrl}
            description={description}
            price={price}
            itemIndicator={itemIndicator}
            onAddClick={onAddClick}
            onRemoveClick={onRemoveClick}
            t={t}
        />
    )
}

export default AddonsItemCardWrapper
